//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    tabList: {
      type: Array,
      required: true,
    },
    isTab: {
      type: Boolean,
      default: () => true,
    },
    isUrlChangeTab: {
      type: Boolean,
      default: () => false,
    },
    isMobileScroll: {
      type: Boolean,
      default: () => false,
    },
    center: {
      type: Boolean,
      default: () => false,
    },
    variant: {
      type: String,
      required: false,
      default: () => 'vertical',
      validator: (value) => ['horizontal', 'vertical'].includes(value),
    },
  },
  data() {
    return {
      activeTab: this.$route.query.tab ? Number(this.$route.query.tab) : 1,
    }
  },
  watch: {
    '$route.query'() {
      if (this.$route.query.tab) {
        this.activeTab = Number(this.$route.query.tab)
      }
    },
  },
  methods: {
    onChangeTab() {
      if (this.isUrlChangeTab) {
        this.$router.replace(`/gold-points?tab=${Number(this.activeTab)}`)
      }
    },
  },
}
